import { adminHttpClient } from '../../../../commons/adminHttpClient'

const getAttachments = (): Promise<any> => {
  return adminHttpClient.get('/EEDashboard/GetReimbursed/Expense/Attachments')
}

export default getAttachments
